import { compareItems, rankItem,  } from "@tanstack/match-sorter-utils"
import { FilterFn, SortingFn, sortingFns } from "@tanstack/react-table"
import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
 
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const fuzzyFilter: FilterFn<any> = (row, columnId, value, addMeta) => {


  let itemRank = {
    passed: false
  }

  if (Array.isArray(value)) {
    
    for (const v of value) {
      const t = rankItem(row.getValue(columnId), v)

      if (t.passed) {
        itemRank = rankItem(row.getValue(columnId), v)
      }
    }
  }

  if (typeof value === "string") {
    itemRank = rankItem(row.getValue(columnId), value)
  }
  

  // Store the itemRank info
  addMeta({
    itemRank,
  })

  // Return if the item should be filtered in/out
  return itemRank.passed
}

export const fuzzyFilterBoolean: FilterFn<any> = (row, columnId, value, addMeta) => {
  // Rank the item
  const itemRank = rankItem(JSON.stringify(Boolean(row.getValue(columnId))), value)

  // Store the itemRank info
  addMeta({
    itemRank,
  })

  // Return if the item should be filtered in/out
  return itemRank.passed
}
